import { setGlobal } from 'reactn';

// Simple React Store

setGlobal({
  afterLoginRedirectUri: undefined,
});
